import MainLayout from "@/components/layout/admin/MainLayout.vue";
import Loading from 'vue-loading-overlay';
import 'vue-loading-overlay/dist/vue-loading.css';
import CONFIG from "@/assets/js/config.js";
import AdvancedLaravelVuePaginate from 'advanced-laravel-vue-paginate';
import 'advanced-laravel-vue-paginate/dist/advanced-laravel-vue-paginate.css';
import flatPickr from 'vue-flatpickr-component';
import 'flatpickr/dist/flatpickr.css';
import axios from 'axios';
import HandlePaginateService from "@/services/HandlePaginateService";

export default {
  name: "positionList",
  components: {
    MainLayout,
    flatPickr,
    Loading,
    CONFIG,
    AdvancedLaravelVuePaginate
  },

  data() {
    return {
      positionLists: {},
      searchData: {
        position_name: '',
        description: '',
        min_salary: '',
        max_salary: ''
      },
      total: null,
      isLoading: false,
      currentPage: 1,
      noDataMsg: CONFIG.NO_DATA_FOUND,
      search_status: false,
      currency: '',
      positionName: '',
      description: '',
      minSalary: '',
      maxSalary: ''
    };
  },

  methods: {
    getPositionLists(page = 1) {
      this.currentPage = page;
      this.isLoading = true;
      this.search_status = false;
      axios.get('/position?page=' + page)
        .then((response) => {
          this.positionLists = response.data.positions;
          this.currency = response.data.currency;
        })
        .catch((err) => {
          if (err && err.response && err.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else {
            console.error(err);
          }
        })
        .finally(() => {
          this.isLoading = false;
        })
    },

    search(page = 1) {
      this.isLoading = true;
      this.search_status = true;
      this.currentPage = page;
      axios.get('position/search?page=' + page, {
        params: {
          position_name: this.searchData.position_name,
          description: this.searchData.description,
          min_salary: this.searchData.min_salary,
          max_salary: this.searchData.max_salary
        }
      })
        .then(res => {
          if (res.data) {
            this.positionLists = res.data;
          }
          this.isLoading = false;
        }).catch(error => {
          if (error.response.status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          }
          this.isLoading = false;
        })
    },

    filterBasicSalary(field) {
      let value = this.searchData[field];
      value = value.replace(/[^0-9]/g, '');
      value = value.replace(/^0+/, '');
      this.searchData[field] = value ? parseInt(value) : null;
    },

    reset() {
      this.positionName = '';
      this.description = '';
      this.minSalary = '';
      this.maxSalary = '';
      this.searchData = {
        position_name: '',
        description: '',
        min_salary: '',
        max_salary: ''
      }
      this.isLoading = true;
      this.getPositionLists();
    },

    filter() {
      this.search_status = false;
      this.searchData.position_name = this.positionName;
      this.searchData.description = this.description;
      this.searchData.min_salary = this.minSalary;
      this.searchData.max_salary = this.maxSalary;
      this.search();
    },

    showEdit(id) {
      this.$router.push({
        name: "positionEdit",
        params: {
          id: id
        }
      });
    },

    showDetail(id) {
      this.$router.push({
        name: "positionDetail",
        params: {
          id: id
        }
      });
    },

    confirmDelete(id) {
      if (window.confirm("Are you sure you want to delete?")) {
        this.deletePosition(id);
      }
    },

    deletePosition(id) {
      this.isLoading = true;
      axios.delete("position/" + id)
        .then(response => {
          if (response.data.success == true) {
            HandlePaginateService.afterDelete({
              listData: this.positionLists,
              currentPage: this.currentPage,
              isSearch: this.search_status,
              searchFn: this.search,
              listFn: this.getPositionLists
            });
            this.$notification.success('Position Deleted Successfully', {
              timer: 3,
              position: "bottomCenter"
            });
          }
        })
        .catch(error => {
          if (!error.response) {
            console.log("Position Delete Error", error);
            return;
          }
          const status = error.response.status;
          if (status == 401) {
            this.$store.commit('logout');
            window.location.replace('login');
          } else if (status == 422) {
            this.$notification.error(error.response.data.message, {
              timer: 3,
              position: "bottomCenter"
            });
            this.getPositionLists();
          } else {
            this.$notification.error("Something went wrong. Please try again.", {
              timer: 3,
              position: "bottomCenter"
            });
          }
        }).finally(() => {
          this.isLoading = false;
        });
    },

    handlePaginate(page) {
      HandlePaginateService.paginate({
        page,
        isSearch: this.search_status,
        searchFn: this.search,
        listFn: this.getPositionLists
      })
    },
  },

  mounted() {
    this.isLoading = true;
    this.getPositionLists();
  },
};
